import { useMutation, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import axiosClient from "../lib/axios";  
import { CONTENT_TAREFA_KEYS } from "../constants/contentTarefaConstants";

export interface ResolverTarefaInput {
  tarefa_id: number;
  observacoes: string;
  resposta: string;
  resposta_files?: string[];
  anexos?: (File | null)[];
  [key: string]: any;
}

interface DevolverTarefaInput {
  idProcesso: number;
  motivoCancelamento: string;
}

interface ReprocessarTarefaInput {
  tarefa_id: number;
  forcar: boolean;
  observacoes: string;
}

export function useTarefaMutations() {
  const queryClient = useQueryClient();

  const resolverTarefa = useMutation({
    mutationKey: "resolver-tarefa",
    mutationFn: (inputs: ResolverTarefaInput) =>
      axiosClient.post("/resolver-tarefa", inputs, {
        headers: { "Content-Type": "multipart/form-data" },
      }),
    onError: (error) => {
      console.error(error);
      enqueueSnackbar("Erro ao resolver tarefa!", { variant: "error" });
    },
    onSuccess: () => {
      enqueueSnackbar("Tarefa resolvida com sucesso!", {
        variant: "success",
      });
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.DETALHAR_PROCESSO);
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.PESQUISAR_PROCESSOS_FAZENDO);
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.PESQUISAR_PROCESSOS_FINALIZADOS);
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.PESQUISAR_TAREFAS_PARA_FAZER);
    },
  });

  const devolverTarefa = useMutation({
    mutationKey: "devolver-tarefa-atual",
    mutationFn: ({
      idProcesso,
      motivoCancelamento,
    }: DevolverTarefaInput) => {
      return axiosClient.post(`/devolver-tarefa-atual/${idProcesso}`, {
        observacoes_cancelamento: motivoCancelamento,
      });
    },
    onError: (error) => {
      console.error(error);
    },
    onSuccess: () => {
      enqueueSnackbar("Tarefa devolvida com sucesso!", {
        variant: "success",
      });
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.DETALHAR_PROCESSO);
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.PESQUISAR_PROCESSOS_FAZENDO);
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.PESQUISAR_PROCESSOS_FINALIZADOS);
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.PESQUISAR_TAREFAS_PARA_FAZER);
    },
  });

  const reprocessarTarefa = useMutation({
    mutationKey: "reprocessar-tarefa",
    mutationFn: (inputs: ReprocessarTarefaInput) =>
      axiosClient.post("/reprocessar-tarefa", inputs),
    onError: (error) => {
      console.error(error);
      enqueueSnackbar("Erro ao reprocessar tarefa!", { variant: "error" });
    },
    onSuccess: () => {
      enqueueSnackbar("Reprocessamento realizado com sucesso!", {
        variant: "success",
      });
      queryClient.invalidateQueries(CONTENT_TAREFA_KEYS.DETALHAR_PROCESSO);
    },
  });

  return {
    mutateResolverTarefa: resolverTarefa.mutate,
    isLoadingResolverTarefa: resolverTarefa.isLoading,
    mutateDevolverTarefa: devolverTarefa.mutate,
    isLoadingDevolverTarefa: devolverTarefa.isLoading,
    mutateReprocessarTarefa: reprocessarTarefa.mutate,
    isLoadingReprocessarTarefa: reprocessarTarefa.isLoading,
  };
}